import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const timelineData = [{
  days: 'Días 1–3',
  desc: 'Descubrir que tu "lugar raro" tiene propósito — Ester también llegó a donde no esperaba'
}, {
  days: 'Días 4–6',
  desc: 'Reconocer que tu proceso silencioso era preparación real, no tiempo perdido'
}, {
  days: 'Días 7–9',
  desc: 'Entender el "Principio Ester" — cómo Dios te posiciona antes de revelarte el momento'
}, {
  days: 'Días 10–11',
  desc: 'Despertar tu valentía — el momento llega, y necesitas estar dispuesta, no perfecta'
}, {
  days: 'Día 12',
  desc: 'Declarar con fe: "Fui llamada para este momento" — y creerlo completamente'
}];
export function Timeline() {
  return <section className="py-10 px-5" data-id="element-288">
      <div className="max-w-lg mx-auto" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-7" data-id="element-290">
          <h2 className="font-serif text-xl sm:text-2xl text-cream-100" data-id="element-291">
            Lo que vivirás en estos 12 días:
          </h2>
        </motion.div>

        <div className="relative" data-id="element-292">
          {/* Vertical Line */}
          <div className="absolute left-[23px] top-2 bottom-2 w-[1px] bg-gradient-to-b from-gold-500/50 via-gold-500/20 to-transparent" data-id="element-293"></div>

          <div className="space-y-5" data-id="element-294">
            {timelineData.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative pl-14" data-id="element-295">
                {/* Node */}
                <div className="absolute left-[19px] top-1 w-2.5 h-2.5 rounded-full bg-gold-400 shadow-[0_0_10px_rgba(212,168,87,0.5)]" data-id="element-296"></div>

                <h3 className="font-serif text-gold-400 text-base mb-0.5" data-id="element-297">
                  {item.days}
                </h3>
                <p className="text-cream-300/80 text-[13.5px] leading-snug font-light" data-id="element-298">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        <Ornament className="mt-7" data-id="element-299" />
      </div>
    </section>;
}